<div class="login-container">
  <div class="login-card-container">
    <mat-card class="login-card">
      <mat-card-header>
        <mat-card-title>
          <span (dblclick)="onDoubleClickTitle()">
            <ng-content select="[login-title]"></ng-content>
          </span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (isValidInstance) {
          @if (showInternalUserLogin) {
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="on">
              <mat-form-field appearance="fill">
                <mat-label transloco="USERNAME"></mat-label>
                <input
                  id="username"
                  name="username"
                  matInput
                  type="text"
                  formControlName="username"
                  autocomplete="username"
                  class="form-control"
                />
                @if (this.f.username.invalid) {
                  <mat-error>
                    {{ userInputError }}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label transloco="PASSWORD"></mat-label>
                <input
                  id="password"
                  name="password"
                  matInput
                  type="password"
                  formControlName="password"
                  autocomplete="current-password"
                  class="form-control"
                />
                @if (this.f.password.invalid) {
                  <mat-error>{{ passwordInputError }}</mat-error>
                }
              </mat-form-field>
              <ngx-login-button [disabled]="loading" [loading]="loadingBasic">
                <ngx-logo-svg button-icon></ngx-logo-svg>
                <span button-text transloco="LOGIN"></span>
              </ngx-login-button>
            </form>
          }
          @if ((providersExist || guestLoginEnabled) && showInternalUserLogin) {
            <ngx-divider-with-text
              [text]="'OR' | transloco"
            ></ngx-divider-with-text>
          }
          @if (guestLoginEnabled) {
            <ngx-login-button
              [disabled]="loading"
              [loading]="loadingGuest"
              (click)="onGuestLogin()"
            >
              <ngx-logo-svg button-icon></ngx-logo-svg>
              <span button-text transloco="LOGIN_AS_GUEST"></span>
            </ngx-login-button>
          }
          @if (ntlmAuthentication$ | async) {
            <ngx-login-button [disabled]="loading" (click)="onWindowsLogin()">
              <mat-icon
                button-icon
                class="svg-button-icon"
                svgIcon="microsoft"
              ></mat-icon>
              <span button-text>Windows</span>
            </ngx-login-button>
          }
          @if (providersExist) {
            @if (hasProvider('okta')) {
              <ngx-login-button
                background-color="#007dc1"
                color="#fff"
                [disabled]="loading"
                [loading]="loadingOkta"
                (click)="onOktaLogin()"
              >
                <div id="okta-circle" button-icon></div>
                <span button-text>Okta</span>
              </ngx-login-button>
            }
            @if (hasProvider('azure')) {
              <ngx-login-button
                background-color="#334"
                color="#fff"
                [disabled]="loading"
                [loading]="loadingAzure"
                (click)="onMicrosoftLogin()"
              >
                <mat-icon
                  class="svg-button-icon"
                  svgIcon="microsoft"
                  button-icon
                ></mat-icon>
                <span button-text class="microsoft-button-label"
                  >Microsoft</span
                >
              </ngx-login-button>
            }
            @if (hasProvider('onelogin')) {
              <ngx-login-button
                background-color="#3a3e51"
                color="#fff"
                [disabled]="loading"
                [loading]="loadingOnelogin"
                (click)="onOneLogin()"
              >
                <div id="one-one" button-icon></div>
                <span button-text>OneLogin</span>
              </ngx-login-button>
            }
            @if (hasProvider('google')) {
              <ngx-login-button
                background-color="#ffffff"
                color="#444"
                [disabled]="loading"
                [loading]="loadingGoogle"
                (click)="onGoogleLogin()"
              >
                <mat-icon
                  class="svg-button-icon"
                  svgIcon="google"
                  button-icon
                ></mat-icon>
                <span button-text>Google</span>
              </ngx-login-button>
            }
            @if (hasProvider('duo')) {
              <ngx-login-button
                background-color="#6bbf4e"
                color="#fff"
                [disabled]="loading"
                [loading]="loadingDuo"
                (click)="onDuoLogin()"
              >
                <mat-icon
                  class="svg-button-icon"
                  svgIcon="duo"
                  button-icon
                ></mat-icon>
                <span button-text>Duo</span>
              </ngx-login-button>
            }
            @for (
              providerKeyPair of genericProviders$ | async | keyvalue;
              track providerKeyPair.key
            ) {
              @if (
                providerKeyPair.value.genericProviderButtonConfiguration;
                as buttonConfiguration
              ) {
                <ngx-login-button
                  [background-color]="buttonConfiguration.backgroundColor"
                  [color]="buttonConfiguration.color"
                  [disabled]="loading"
                  [loading]="loadingGenericProvider"
                  (click)="onGenericProviderLogin(providerKeyPair.key)"
                >
                  <mat-icon
                    class="svg-button-icon"
                    [svgIcon]="buttonConfiguration.svgIcon ?? 'openid'"
                    button-icon
                  ></mat-icon>
                  <span
                    button-text
                    [class.openid-button-label]="!buttonConfiguration.svgIcon"
                    >{{ buttonConfiguration.buttonText }}</span
                  >
                </ngx-login-button>
              }
            }
          }
        }
        <app-api-url-field
          [(url)]="instanceUrl"
          (isValidChanged)="isValidInstance = $event"
        ></app-api-url-field>
        @if (error) {
          <div id="error-box">
            <span [transloco]="error"></span>
            <button
              id="error-close-btn"
              mat-icon-button
              (click)="onClearError()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </mat-card-content>
      <mat-card-footer>
        <div id="tos">
          Your use of this service constitutes acceptance of the
          <a id="tos-link" [href]="tosUrl$ | async" target="_blank">Terms</a>.
        </div>
      </mat-card-footer>
    </mat-card>
  </div>
  @if (
    (hideLoginSidePanel$ | async) === false &&
    (isSmallViewport$ | async) === false
  ) {
    <div class="login-side-panel-container">
      <ng-container *ngTemplateOutlet="sidePanel"></ng-container>
    </div>
  }
</div>
@if (
  (hideLoginSidePanel$ | async) === false && (isSmallViewport$ | async) === true
) {
  <ng-container *ngTemplateOutlet="sidePanel"></ng-container>
}

<ng-template #sidePanel>
  <iframe id="side-frame" [src]="loginSidePanelUrl$ | async" frameborder="0">
  </iframe>
</ng-template>
